import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import GradientButton from './GradientButton';

function CvNavigation({ backlink, nextlink, onNext }) {
  const navigate = useNavigate();

  const handleNextClick = async () => {
    if (typeof onNext === 'function') {
      await onNext();
    }
    navigate(nextlink);
  };

  return (
    <div className="row g-3 mt-2">
      <div className="d-flex justify-content-between">
        <GradientButton
          onClick={() => navigate(backlink)}
          gradient="pink"
        >
          <FaArrowLeft className="me-2" />
          Wstecz                            
        </GradientButton>
        <GradientButton
          onClick={handleNextClick}
          gradient="blue"
        >
          Dalej
          <FaArrowRight className="ms-2" />                  
        </GradientButton>
      </div>
    </div>
  );
}

export default CvNavigation;